import {ServerError} from "../../../typescript-plugin/error/ServerError";

export class TakenDateError extends ServerError{
    constructor() {
        super("User reservation contains taken date");
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/error/TakenDateError.ts